import { observer } from 'mobx-react-lite'

export const WidgetEmpty = observer(() => {
  return null
})
